export const IdeaLogoBadge = () => (
  <div data-testid="idea-logo-badge" className="flex h-10 shrink-0 items-center rounded-md bg-black px-2.5">
    <img src="/brand/idea-logo.png" alt="IDEA" data-testid="idea-logo-img" className="block h-[24px] w-auto" />
  </div>
);
